//================ Slick Slider Code ================//

/* Home Slider */
var item_length = $('.slick-multislider > div').length - 1; // Check how many slides exist

function mobileOnlySlider() {
	$('.slick-multislider-banner').slick({
	  autoplay: true,
	  autoplaySpeed: 4000,
	  arrows: false
	});
	
	$('.slick-home-features').slick({
	  autoplay: true,
	  autoplaySpeed: 3000,
	  arrows: false
	});
}
if(window.innerWidth < 768) {
	mobileOnlySlider();
}

$(window).resize(function(e){
  if (window.innerWidth < 768) {
    if (!$('.slick-multislider-banner').hasClass('slick-initialized')) {
      mobileOnlySlider();
    }
  } else {
    if ($('.slick-multislider-banner').hasClass('slick-initialized')) {
      $('.slick-multislider-banner').slick('unslick');
      $('.slick-home-features').slick('unslick');
    }
  }
});


/* Other Products You'll Love */
function desktopMoreProducts() {
	$('.slick-more-products').slick({
	  slidesToShow: 5,
	  autoplay: true,
	  autoplaySpeed: 2500,
	  arrows: true,
	  prevArrow: $('.more-prev-arrow'),
		nextArrow: $('.more-next-arrow')
	});
}
if(window.innerWidth > 900) {
	desktopMoreProducts();
}

function tabletMoreProducts() {
	$('.slick-more-products').slick({
	  slidesToShow: 3,
	  autoplay: true,
	  autoplaySpeed: 2500,
	  arrows: true,
	  prevArrow: $('.more-prev-arrow'),
		nextArrow: $('.more-next-arrow')
	});
}
if(window.innerWidth > 650 && window.innerWidth < 900) {
	tabletMoreProducts();
}

function mobileMoreProducts() {
	$('.slick-more-products').slick({
	  slidesToShow: 2,
	  autoplay: true,
	  autoplaySpeed: 2500,
	  arrows: true,
	  prevArrow: $('.more-prev-arrow'),
		nextArrow: $('.more-next-arrow')
	});
}
if(window.innerWidth < 650) {
	mobileMoreProducts();
}

$(window).resize(function(e){
  
  /* Other Products You'll Love */
  if (window.innerWidth > 900) {
    if ($('.slick-more-products').hasClass('slick-initialized')) {
      $('.slick-more-products').slick('unslick');
      desktopMoreProducts();
    }
  } else if (window.innerWidth > 650 && window.innerWidth < 900) {
    if ($('.slick-more-products').hasClass('slick-initialized')) {
      $('.slick-more-products').slick('unslick');
      tabletMoreProducts();
    }
  } else {
    if ($('.slick-more-products').hasClass('slick-initialized')) {
      $('.slick-more-products').slick('unslick');
      mobileMoreProducts();
    }
  }
  
});